/* eslint-disable @angular-eslint/component-selector */
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, contentChild, input } from '@angular/core';

import { TimelineItemDefDirective } from './timeline-item-def.directive';

@Component({
  selector: 'ol[ui-timeline]',
  imports: [NgTemplateOutlet],
  template: `
    @for (event of events(); track $index; let index = $index) {
      <ng-container *ngTemplateOutlet="timelineItem(); context: { $implicit: event, index: index }" />
    }
  `,
  styles: `
    :host {
      --timeline-line-color: var(--sys-outline);
      --timeline-line-style: solid;
      --timeline-line-width: 2px;
      --timeline-marker-width: 16px;

      background-color: inherit;
      list-style: none;
      margin: 0;
      padding: 0;

      &::ng-deep li:last-of-type {
        --timeline-line-color: transparent !important;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineComponent {
  public readonly timelineItem = contentChild.required(TemplateRef<TimelineItemDefDirective>);
  public readonly events = input<any[]>([]);
}
